import React from 'react';
import FigmaBadge from '../../../Elements/FigmaBadge';

const STATUS_VARIANTS = ['created', 'confirmed', 'planned', 'completed', 'todo', 'progress', 'testing', 'uat'];

function cap(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function BadgesDemoComponent() {
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Active / inactive</div>
        <FigmaBadge Active={true} />
        <FigmaBadge Active={false} />
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Custom active labels</div>
        <FigmaBadge
          Active={true}
          ActiveText='Enabled'
          InactiveText='Disabled'
        />
        <FigmaBadge
          Active={false}
          ActiveText='Enabled'
          InactiveText='Disabled'
        />
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Status variants</div>
        {STATUS_VARIANTS.map((v) => (
          <FigmaBadge
            key={v}
            variant={v}
            label={cap(v)}
          />
        ))}
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Custom width & tooltip</div>
        <FigmaBadge
          Active={true}
          ActiveText='Published'
          width={110}
          tooltip='Visible to clients'
        />
        <FigmaBadge
          Active={false}
          ActiveText='Published'
          InactiveText='Draft'
          width={110}
          tooltip='Not yet visible'
        />
      </div>
    </div>
  );
}

export const badgesDemo = {
  id: 'badges',
  title: 'Badges',
  category: 'Basics',
  importPath: 'src/Elements/FigmaBadge.js',
  notes: [
    'One unified pill component for both binary state and named statuses: <FigmaBadge />. Replaces the old CSS-only .status pills.',
    'Binary: <FigmaBadge Active={item.IsActive} /> → green "active" / gold "inactive" pill. ActiveText/InactiveText override the labels; width (px, default 80) fixes the column width; tooltip sets the title.',
    'Named status: <FigmaBadge variant="confirmed" label="Confirmed" />. Variants: created, confirmed, planned, completed (business) + todo, progress, testing, uat (dev). variant wins over Active when both are set; variant pills are auto-width.',
    'Styling lives in src/index.css (.badgebase family), global/unscoped so it renders on non-bravo-ds pages too (unlike the retired .bravo-ds .status rules).',
    'Home dev-news maps Jira status names to a variant via statusPillClass() in Contents/Home/homeHelpers.ts — reuse it rather than hardcoding.',
  ],
  snippet:
    '// binary state\n<FigmaBadge Active={item.IsActive} />\n\n// named status\n<FigmaBadge variant={statusPillClass(item.StatusName)} label={item.StatusName} />',
  render: BadgesDemoComponent,
};
